import jadeTheme from '@stone-payments/jade-design-tokens/cjs/stone';
import styled from 'styled-components';

export const PaymentMethodSelectionContent = styled.div<{ index: number, acceptedPaymentMethods: string[] }>`
  margin-bottom: ${p => (p.index !== p.acceptedPaymentMethods.length-1 && jadeTheme.global.space[150])};
  margin-top: ${jadeTheme.global.space[300]} 0px;
`

export const PaymentMethodSelectionContainer = styled.div`
  width: 100%;
`
